import React, { Fragment, useState, useEffect } from "react";
import { Alert, Button, Modal, Form, Spinner } from "react-bootstrap";
import PageTitle from "../../../layouts/PageTitle";
import axios from "axios";
import swal from "sweetalert";

const Checkout = () => {
  const [depositInput, setDepositInput] = useState({
    wallet_add: '',
    accountType: 'trc_20',
    password: '',
    error_list: [],
  });

  const [loading, setLoading] = useState(false);
  const [income, setIncome] = useState([]);
  const [loadingdd, setLoadingotp] = useState(false);

  const handleInput = (e) => {
    setDepositInput({ ...depositInput, [e.target.name]: e.target.value });
  };

  const fetchIncomeData = () => {
    const selectedCurrency = localStorage.getItem('selectedCurrency');
    const auth_token = localStorage.getItem('auth_token');
    const data = {
      key_s: 'eyJ0eXAiOiJKV1Qidfg%!#%$%LCdf#*&*JhbGciOiJSUzI1NiJ9',
      currency: selectedCurrency,
    };

    if (auth_token) {
      axios.post('/get-method', data)
        .then(response => {
          setIncome(response.data.data);
        })
        .catch(error => {
          console.error(error);
        });
    }
  };

  useEffect(() => {
    fetchIncomeData();
  }, []);

  const depositSubmit = (e) => {
    e.preventDefault();
    const auth_token = localStorage.getItem('auth_token');
    const data = {
      wallet_add: depositInput.wallet_add,
      accountType: depositInput.accountType,
      with_otp: depositInput.with_otp,
      password: depositInput.password,
      key_s: 'eyJ0eXAiOiJKV1Qidfg%!#%$%LCdf#*&*JhbGciOiJSUzI1NiJ9',
    };

    if (auth_token && !loading) {
      setLoading(true);
      axios.post('/sub-method', data)
        .then(res => {
          if (res.data.status === 'success') {
            swal("Success", res.data.message, "success");
            setDepositInput({ wallet_add: '', accountType: 'trc_20', password: '', error_list: [] });
            fetchIncomeData();
          } else if (res.data.status === 'fail') {
            swal("Warning", res.data.message, "warning");
          } else {
            setDepositInput({ ...depositInput, error_list: res.data.validation_error });
          }
          setLoading(false);
        })
        .catch(() => setLoading(false));
    }
  };

  const handleLinkClick = () => {
    const auth_token = localStorage.getItem('auth_token');
    const data = {
      key_s: 'eyJ0eXAiOiJKV1Qidfg%!#%$%LCdf#*&*JhbGciOiJSUzI1NiJ9',
      root_url: "https://account.segma.app/",
    };
    if (auth_token && !loadingdd) {
      setLoadingotp(true);
      axios.post('/email-met-withdraw-verify', data)
        .then(res => {
          setLoadingotp(false);
          if (res.data.status === 'success') {
            swal("success", res.data.message, "success");
          } else {
            swal("Warning", res.data.message, "warning");
          }
        })
        .catch(error => {
          setLoadingotp(false);
          console.log(error);
        });
    }
  };

  return (
    <Fragment>
      <div className="row">
        <div className="col-lg-6">
          <div className="card shadow-sm border-0 p-4">
            <h4 className="mb-4 text-primary">Setup Your Withdrawal Method</h4>
            <form onSubmit={depositSubmit}>
              <div className="mb-3">
                <label className="form-label fw-bold">Crypto Wallet Address</label>
                <input
                  type="text"
                  className="form-control"
                  name="wallet_add"
                  placeholder="Enter your crypto wallet address"
                  value={depositInput.wallet_add}
                  onChange={handleInput}
                />
                <small className="text-danger">{depositInput.error_list.wallet_add}</small>
              </div>

              <div className="mb-3">
                <label className="form-label fw-bold">Choose Wallet Type</label>
                <div className="d-flex gap-3">
                  <div className="form-check">
                    <input
                      type="radio"
                      id="trc_20"
                      name="accountType"
                      value="trc_20"
                      className="form-check-input"
                      onChange={handleInput}
                      checked={depositInput.accountType === "trc_20"}
                    />
                    <label className="form-check-label" htmlFor="trc_20">USDT TRC-20</label>
                  </div>
                  <div className="form-check">
                    <input
                      type="radio"
                      id="bep_20"
                      name="accountType"
                      value="bep_20"
                      className="form-check-input"
                      onChange={handleInput}
                      checked={depositInput.accountType === "bep_20"}
                    />
                    <label className="form-check-label" htmlFor="bep_20">USDT BEP-20</label>
                  </div>
                </div>
                <small className="text-danger">{depositInput.error_list.accountType}</small>
              </div>




              <div className="mb-4">
                <label className="form-label fw-bold">Account Password</label>
                <input
                  type="password"
                  className="form-control"
                  name="password"
                  placeholder="Enter your password"
                  value={depositInput.password}
                  onChange={handleInput}
                />
                <small className="text-danger">{depositInput.error_list.password}</small>
              </div>


              <div className="mb-3">
                <label htmlFor="with_otp" className="form-label fw-bold">
                 Send Withdrawal OTP
                </label>

                <div className="col-12">
                  <Alert variant="warning">
                    <div className="d-flex flex-column flex-md-row align-items-md-center gap-2">
                      <input
                        type="text"
                        className="form-control"
                        id="with_otp"
                        placeholder="Enter OTP"
                        name="with_otp"
                        onChange={handleInput}
                        value={depositInput.with_otp}
                        required
                      />
                      <Button
                        variant="success"
                        size="sm"
                        onClick={handleLinkClick}
                        style={{ whiteSpace: 'nowrap' }}
                      >
                        {loadingdd ? 'Sending...' : 'Send Now'}
                      </Button>
                    </div>
                  </Alert>
                </div>

                    {depositInput.error_list.with_otp && (
                      <small className="text-danger">{depositInput.error_list.with_otp}</small>
                    )}
              </div>

              <button type="submit" className="btn btn-primary w-100" disabled={loading}>
                {loading ? <Spinner size="sm" animation="border" /> : "Save Withdrawal Method"}
              </button>
            </form>
          </div>
        </div>

        <div className="col-lg-6 mt-4 mt-lg-0">
          <div className="card shadow-sm border-0 p-4">
            <h4 className="mb-4 text-success">Your Withdrawal Accounts</h4>
            <div className="table-responsive">
              <table className="table table-hover table-striped">
                <thead className="table-light">
                  <tr>
                    <th>Wallet Chain</th>
                    <th>Wallet Address</th>
                    <th>Added On</th>
                  </tr>
                </thead>
                <tbody>
                  {income.length > 0 ? income.map((row) => (
                    <tr key={row.id}>
                      <td className="text-capitalize">{row.wallet_chain}</td>
                      <td style={{ wordBreak: "break-word" }}>{row.wallet_address}</td>
                      <td>{row.create_time}</td>
                    </tr>
                  )) : (
                    <tr>
                      <td colSpan="3" className="text-center text-muted">No records found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* Custom CSS inline */}
      <style>{`
        .form-label {
          font-size: 14px;
        }
        .table td, .table th {
          vertical-align: middle;
        }
        .card {
          border-radius: 12px;
          background: #f9f9f9;
        }
      `}</style>
    </Fragment>
  );
};

export default Checkout;
